import React, { useRef } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import { TabContext } from "@mui/lab";

export const UiNavTab = (props) => {
  const {
    tabNav,
    value,
    onSelect,
    orient = "horizontal",
    children,
    isShowTabList = true,
  } = props;
  const tabRefs = useRef([]);

  const handleChange = (event, newValue) => {
    if (onSelect) onSelect(newValue);

    const tabIndex = tabNav.findIndex((tab) => tab.value === newValue);
    const tabRef = tabRefs.current[tabIndex];

    if (tabRef && tabRef.scrollIntoView) {
      tabRef.scrollIntoView({
        behavior: "smooth",
        inline:
          tabIndex === 0
            ? "start"
            : tabIndex === tabNav.length - 1
              ? "end"
              : "nearest",
        block: "nearest",
      });
    }
  };

  const className = `df-cust-tab${
    props.className ? " " + props.className : ""
  }`;

  return (
    <>
      <Box className={className}>
        <TabContext
          value={value}
          orientation={orient == "vertical" ? "vertical" : "horizontal"}
        >
          {isShowTabList && (
            <Box className="df-segmented-tab-container">
              <TabList
                onChange={handleChange}
                aria-label="dfcc"
                variant="scrollable"
                scrollButtons={false}
                className="df-segmented-tab-list"
              >
                {tabNav.map((tabN, index) => (
                  <Tab
                    key={tabN.id}
                    label={tabN.label}
                    value={tabN.value}
                    ref={(element) => (tabRefs.current[index] = element)}
                    className={`df-segmented-tab ${index === 0 ? "df-segmented-tab-first" : ""} ${index === tabNav.length - 1 ? "df-segmented-tab-last" : ""}`}
                  />
                ))}
              </TabList>
            </Box>
          )}
          {props.children}
        </TabContext>
      </Box>
    </>
  );
};
